import {
  Box,
  Card,
  CardContent,
  MenuItem,
  Stack,
  TextField,
  InputAdornment,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { DATE_PRESET_OPTIONS, STATUS_FILTER_OPTIONS } from './priceConcernUtils'

export function PriceConcernsFilters({ filters, onFiltersChange }) {
  const isCustom = filters.datePreset === 'custom'

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent sx={{ '&:last-child': { pb: 2 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', md: 'flex-end' }}
          flexWrap="wrap"
          useFlexGap
        >
          <TextField
            label="Search"
            size="small"
            value={filters.search}
            onChange={(e) =>
              onFiltersChange((prev) => ({
                ...prev,
                search: e.target.value,
                page: 0,
              }))
            }
            placeholder="Product, article, shop, submitter"
            sx={{ flex: 1, minWidth: { xs: '100%', md: 280 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            select
            label="Review status"
            size="small"
            value={filters.status ?? ''}
            onChange={(e) =>
              onFiltersChange((prev) => ({
                ...prev,
                status: e.target.value,
                page: 0,
              }))
            }
            InputLabelProps={{ shrink: true }}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) =>
                STATUS_FILTER_OPTIONS.find((opt) => opt.value === selected)?.label ??
                'All',
            }}
            sx={{ minWidth: 170 }}
          >
            {STATUS_FILTER_OPTIONS.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Date"
            size="small"
            value={filters.datePreset ?? ''}
            onChange={(e) => {
              const next = e.target.value
              onFiltersChange((prev) => ({
                ...prev,
                datePreset: next,
                dateFrom: next === 'custom' ? prev.dateFrom : '',
                dateTo: next === 'custom' ? prev.dateTo : '',
                page: 0,
              }))
            }}
            InputLabelProps={{ shrink: true }}
            SelectProps={{
              displayEmpty: true,
              renderValue: (selected) =>
                DATE_PRESET_OPTIONS.find((opt) => opt.value === selected)?.label ??
                'All dates',
            }}
            sx={{ minWidth: 170 }}
          >
            {DATE_PRESET_OPTIONS.map((opt) => (
              <MenuItem key={opt.value || 'all-dates'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>

          {isCustom && (
            <Box
              sx={{
                display: 'flex',
                gap: 1.5,
                flexWrap: 'wrap',
                alignItems: 'flex-end',
              }}
            >
              <TextField
                label="From"
                type="date"
                size="small"
                value={filters.dateFrom}
                onChange={(e) =>
                  onFiltersChange((prev) => ({
                    ...prev,
                    dateFrom: e.target.value,
                    page: 0,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 150 }}
              />
              <TextField
                label="To"
                type="date"
                size="small"
                value={filters.dateTo}
                onChange={(e) =>
                  onFiltersChange((prev) => ({
                    ...prev,
                    dateTo: e.target.value,
                    page: 0,
                  }))
                }
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 150 }}
              />
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  )
}
